module.exports = __webpack_public_path__ + "media/hisasiburi.04ec17b6.mp3";